import React from 'react';
import { Icon } from '../core/Icon.jsx';

/**
 * Modal — centered dialog over a scrim. Controlled via `open`/`onClose`.
 * `title` renders a header with a close button; `footer` pins actions at the bottom.
 */
export function Modal({ open, onClose, title, subtitle, footer, width = 480, children, style = {}, ...rest }) {
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && open) onClose && onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <div style={{
      position: 'absolute', inset: 0, zIndex: 100,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      background: 'rgba(2,6,15,.66)',
      opacity: open ? 1 : 0, pointerEvents: open ? 'auto' : 'none',
      transition: 'opacity .18s ease', fontFamily: 'var(--font-sans)',
    }} onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width, maxWidth: '100%', maxHeight: '100%', overflowY: 'auto',
          background: 'var(--surface)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-raised)',
          transform: open ? 'translateY(0) scale(1)' : 'translateY(12px) scale(.98)',
          transition: 'transform .2s cubic-bezier(.22,1,.36,1)', ...style,
        }}
        {...rest}
      >
        {title && (
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, padding: '20px 24px 0' }}>
            <div>
              <h2 style={{ margin: 0, fontSize: 'var(--fs-h2)', fontWeight: 800, color: 'var(--text-strong)' }}>{title}</h2>
              {subtitle && <p style={{ margin: '6px 0 0', fontSize: 'var(--fs-sm)', fontWeight: 500, color: 'var(--text-faint)' }}>{subtitle}</p>}
            </div>
            <button onClick={onClose} aria-label="Cerrar" style={{
              width: 36, height: 36, borderRadius: 10, border: 'none', flexShrink: 0,
              background: 'var(--surface-2)', color: 'var(--text-faint)', cursor: 'pointer',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <Icon name="x" size={18} />
            </button>
          </div>
        )}
        <div style={{ padding: '20px 24px' }}>{children}</div>
        {footer && (
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, padding: '0 24px 22px' }}>{footer}</div>
        )}
      </div>
    </div>
  );
}
